import React from 'react';

interface GridLoaderProps {
  loading?: boolean;
  color?: string;
  speedMultiplier?: number;
  size?: number | string;
  margin?: number | string;
  count?: number; // 圆点个数，默认9个
  cssOverride?: React.CSSProperties;
  className?: string;
}

const GridLoader: React.FC<GridLoaderProps> = ({
  loading = true,
  color = '#5959EB',
  speedMultiplier = 1,
  size = 15,
  margin = 2,
  count = 9,
  cssOverride = {},
  className = '',
  ...additionalProps
}) => {
  // 解析尺寸和边距
  const parseSize = (value: number | string) => {
    if (typeof value === 'number') {
      return `${value}px`;
    }
    return value;
  };

  const sizeWithUnit = parseSize(size);
  const marginWithUnit = parseSize(margin);

  // 计算网格布局：默认3x3，根据count自动调整
  const gridSize = Math.ceil(Math.sqrt(count));
  console.log(sizeWithUnit, marginWithUnit, gridSize);

  const totalWidth = `calc(${sizeWithUnit} * ${gridSize} + ${marginWithUnit} * ${(gridSize - 1) * 2})`;

  // 生成随机延迟
  const random = (top: number) => Math.random() * top;

  // 圆点样式
  const getDotStyle = (rand: number): React.CSSProperties => ({
    display: 'inline-block',
    backgroundColor: color,
    width: sizeWithUnit,
    height: sizeWithUnit,
    margin: marginWithUnit,
    borderRadius: '100%',
    animationFillMode: 'both',
    animation: `gridLoader ${(rand / 100 + 0.6) / speedMultiplier}s ${rand / 100 - 0.2}s infinite ease`
  });

  // 容器样式
  const wrapperStyle: React.CSSProperties = {
    width: totalWidth,
    fontSize: 0,
    display: 'inline-block',
    ...cssOverride
  };

  if (!loading) {
    return null;
  }

  return (
    <>
      <style>
        {`
          @keyframes gridLoader {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(0.5);
              opacity: 0.7;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
      <span style={wrapperStyle} className={className} {...additionalProps}>
        {Array.from({ length: count }, (_, index) => (
          <span key={index} style={getDotStyle(random(100))} />
        ))}
      </span>
    </>
  );
};

export default GridLoader;
